import {FC} from 'react'
import {Link} from 'react-router-dom'
import {EMAIL_TYPES} from 'consts/emailType'
import {generateDynamicPath, WITH_AUTH_ADMIN_PATHS} from 'consts/paths'

// @ts-ignore
import ListGroup from 'jbc-front/components/ListGroup'

export const Index: FC = () => (
  <div>
    <div className="l-main-title-wrap">
      <h1 className="m-title-main">メールカスタマイズ</h1>
      <p className="m-title-main-note">メールの内容をカスタマイズできます</p>
    </div>
    <div className="l-wrap-xs l-contents-wrap">
      <div className="l-breadcrumb u-mb20">
        <Link to={WITH_AUTH_ADMIN_PATHS.SETTINGS.INDEX} className="l-breadcrumb-link">
          設定
        </Link>
        <span className="l-breadcrumb-here">メールカスタマイズ</span>
      </div>
      <ListGroup>
        <ListGroup.Title>メールカスタマイズ</ListGroup.Title>
        {Object.entries(EMAIL_TYPES).map(([type, name]) => (
          <ListGroup.Item
            as={Link}
            to={generateDynamicPath(WITH_AUTH_ADMIN_PATHS.SETTINGS.CUSTOM_MAILS.EDIT, [
              {pattern: 'emailType', replacement: type},
            ])}
            key={type}
          >
            {name}
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  </div>
)
